export default __webpack_public_path__ + "assets/mp3/681a7a4954347f841ed820701252bcf2.mp3";